import { useState } from "react";
import { Link } from "react-router";
import { Button } from "@shop/ui";
import { formatPrice } from "@shop/utils";
import { useCart } from "../store.ts";
import { Pic } from "../components/Pic.tsx";
import { applyCoupon } from "../coupon.ts";

export default function Cart() {
  const { items, remove } = useCart();
  const [code, setCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [tried, setTried] = useState(false);
  const subtotal = items.reduce((n, i) => n + i.product.price * i.qty, 0);
  const total = subtotal - discount;
  if (items.length === 0) return <p className="empty">购物车是空的。<Link to="/">去逛逛</Link></p>;
  return (
    <>
      <h1>购物车</h1>
      {items.map(({ product, qty }) => (
        <div className="cart-row" key={product.id}>
          <Pic name={product.slug} alt="" sizes="80px" />
          <div className="grow"><div>{product.name}</div><div className="stock">× {qty}</div></div>
          <div>{formatPrice(product.price * qty)}</div>
          <Button variant="ghost" onClick={() => remove(product.id)}>删除</Button>
        </div>
      ))}
      <div className="coupon">
        <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="优惠码" aria-label="优惠码" />
        <Button variant="ghost" onClick={() => { setDiscount(applyCoupon(code, subtotal)); setTried(true); }}>使用</Button>
        {discount > 0 && <span className="stock">已减 {formatPrice(discount)}</span>}
        {tried && discount === 0 && <span className="stock">优惠码无效</span>}
      </div>
      <div className="total"><span>合计</span><b>{formatPrice(total)}</b></div>
      <p><Button size="lg" onClick={() => alert("这是示例商城，没有下一步了")}>去结算</Button></p>
    </>
  );
}
